import { gql } from "@apollo/client";

export const GET_WPQ_PROCESSES = gql`
  query GetWpqProcesses {
    getWpqProcesses {
      type
      applicationMethod
    }
  }
`;

export const GET_WPQ_EMPLOYEES = gql`
  query GetWpqEmployees {
    getWpqEmployees {
      id
      externalId
      label
    }
  }
`;

export const GET_WPQ_ROWS_BY_EMPLOYEE = gql`
  query GetWpqRowsByEmployee($employeeId: String!) {
    getWpqRowsByEmployee(employeeId: $employeeId) {
      id
      externalId
      partnerName
      processTitle
      processExpires
      procedure
      wpqTestDate
    }
  }
`;

export const GET_WPQ_ROWS = gql`
  query GetWpqRows($processType: String, $applicationMethod: String, $procedures: [String!]) {
    getWpqRows(processType: $processType, applicationMethod: $applicationMethod, procedures: $procedures) {
      id
      externalId
      partnerName
      processTitle
      processExpires
      procedure
      wpqTestDate
    }
  }
`;

export const GET_WPQ_PDF = gql`
  query GetWpqPdf($externalId: String!) {
    getWpqPdf(externalId: $externalId)
  }
`;

export const GET_WPS_ROWS = gql`
  query GetWpsRows {
    getWpsRows {
      id
      externalId
      name
      processTitle
    }
  }
`;

export const GET_WPS_PDF = gql`
  query GetWpsPdf($externalId: String!) {
    getWpsPdf(externalId: $externalId)
  }
`;

export const GET_WPS_NAMES = gql`
  query GetWpsNames {
    getWpsNames
  }
`;

export const GET_WPQ_PROCEDURES = gql`
  query GetWpqProcedures {
    getWpqProcedures
  }
`;

export const GET_WPQ_BY_EMPLOYEE_NAME = gql`
  query GetWpqByEmployeeName($firstName: String!, $lastName: String!) {
    getWpqByEmployeeName(firstName: $firstName, lastName: $lastName) {
      name
      wpqProcedure
      matchedWpsName
      welderId
      externalId
      createdAt
      testDate
      expirationDate
      points
    }
  }
`;

export const GET_WPQ_BY_EMPLOYEE_NUMBER = gql`
  query GetWpqByEmployeeNumber($employeeNumber: String!) {
    getWpqByEmployeeNumber(employeeNumber: $employeeNumber) {
      id
      name
      wpqProcedure
      matchedWpsName
      welderId
      externalId
      createdAt
      testDate
      expirationDate
      points
    }
  }
`;

export const SEND_WPQ_RENEW_EMAIL = gql`
  mutation SendWpqRenewEmail($wpqId: String!) {
    sendWpqRenewEmail(wpqId: $wpqId)
  }
`;

export default GET_WPQ_PROCESSES;


